"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.partnerGroupParser = exports.PartnerGroupEnum = exports.PartnerNameEnum = void 0;
var PartnerNameEnum;
(function (PartnerNameEnum) {
    PartnerNameEnum["MELIO"] = "melio";
    PartnerNameEnum["BUILT"] = "built-technologies";
    PartnerNameEnum["CAPITAL_ONE"] = "capital-one";
    PartnerNameEnum["CLOVER"] = "clover";
    PartnerNameEnum["SHOPIFY"] = "shopify";
    PartnerNameEnum["MELIO_DEMO"] = "melio-demo";
    PartnerNameEnum["WELLS_FARGO"] = "wells-fargo";
    PartnerNameEnum["SBB"] = "sbb";
    PartnerNameEnum["FISERV"] = "fiserv";
    PartnerNameEnum["DEPLOYMENTS_DEMO"] = "deployments-demo";
    PartnerNameEnum["FISERV_US_BANK"] = "fiserv_us-bank";
})(PartnerNameEnum || (exports.PartnerNameEnum = PartnerNameEnum = {}));
var PartnerGroupEnum;
(function (PartnerGroupEnum) {
    PartnerGroupEnum["FISERV"] = "fiserv";
})(PartnerGroupEnum || (exports.PartnerGroupEnum = PartnerGroupEnum = {}));
const partnerGroupParser = (partnerName) => {
    if (!Object.values(PartnerNameEnum).includes(partnerName)) {
        throw new Error(`Invalid partner name ${partnerName}, should be a valid partnerNameEnum value`);
    }
    if (!partnerName.includes('_')) {
        return { partnerGroup: null };
    }
    const [partnerGroup] = partnerName.split('_');
    if (!Object.values(PartnerGroupEnum).includes(partnerGroup)) {
        throw new Error(`Invalid partner name ${partnerName}, partner group should be a valid partnerGroupEnum value`);
    }
    return { partnerGroup: partnerGroup };
};
exports.partnerGroupParser = partnerGroupParser;
